import React from 'react';
import {Slider} from 'MWC';
import '../../less/apple-setup-card.less';
import '../../less/apple-setup-card-mobile.less';


export default function template() {
    const
        googlePay = (
            <div className="setup-card-body">
                <div>
                    <div className="setup-card-item">
                        <p className="step">
                            {this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 1
                        </p>
                        <p className="desc">{this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_1_DESC')}</p>
                    </div>
                    <div className="setup-card-item">
                        <p className="step">
                            {this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 3
                        </p>
                        <p className="desc">{this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_3_DESC')}</p>
                    </div>
                </div>
                <div>
                    <div className="setup-card-item">
                        <p className="step">
                            {this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 2
                        </p>
                        <p className="desc">{this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_2_DESC')}</p>
                    </div>

                    <div className="setup-card-item">
                        <p className="step">
                            {this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 4
                        </p>
                        <p className="desc">{this.l10n('GOOGLE_PAY_SLOGAN_APPLE_WALLET_STEP_4_DESC')}</p>
                    </div>
                </div>
            </div>
        ),
        current = googlePay;

    return (
        <div className="module-setup-card-container">
            <div className="main-setup-card-content">
                <div className="left-side">
                    <p className="setup-card-title">{this.l10n('GOOGLE_PAY_HELP_TITLE')}</p>
                    {current}
                </div>
                <div className="right-side">
                    <div className="module-setup-card-slider">
                        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/So_NZ47_gm4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
}
